import { bb } from "$json";
/* change-nav-text:
 *
 * Change the nav button text
 * (and class if desired) in any node.
 *
 * Based on config.template.nav-text arr. e.g:

    NB: Array MUST include a default that can be
        be used to reset the states of any button
        which could have been changed.

    "nav-text": [
      {
        "main.introductie": {
          "bb-next": {
            "class": "bb-next extra-class", // Must contain orig. class(es).
            "text": "Start"
          }
        }
      },
      {
        "default": {
          "bb-next": {
            "class": "bb-next",
            "text": "Volgende"
          }
        }
      }
    ]

 * The plugin will look for a .text element inside the button, in case the layer uses SVGs
 * which would otherwise be removed.
 *
 * Author: Tim Bauwens
 * Copyright 2019
 *
 */

(function ($, win, doc) {
  $(function () {
    let navText = bb.propFinder(bb.conf, "template")("nav-text", false);

    const adjustBtn = (btn, change) => {
      let $btn = $(`.${btn}`);
      if (typeof change !== "object" || !$btn.length) return false;
      let $newbtn = $btn.clone();
      let $affect = $newbtn.find(".text").length
        ? $newbtn.find(".text")
        : $newbtn;
      $affect.html(change.text);
      $newbtn.attr("class", change.class);

      return $newbtn;
    };

    if (navText)
      $(doc).on("bb:postHandleData", (e, data) => {
        // Before doing anything, reset the state to default.
        navText.forEach(node => {
          if (node.default !== undefined) {
            $.each(node.default, (btn, change) => {
              let $newbtn = adjustBtn(btn, change);
              if ($newbtn) {
                $(`.${btn}`).replaceWith($newbtn);
              }
            });
          }
        });
        let currentNode = $("fieldset.group:last-of-type").attr("data-node");
        navText.forEach(node => {
          if (node[currentNode] !== undefined) {
            $.each(node[currentNode], (btn, change) => {
              let $newbtn = adjustBtn(btn, change);
              if ($newbtn) {
                $(`.${btn}`).replaceWith($newbtn);
              }
            });
          }
        });
      });
  });
})(jQuery, window, document);
